import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPhone = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 21,
	height: 20,
	viewBox: "0 0 21 20",
	fill: "none",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M5.75769 17.2536C5.5 16.7848 5.5 16.1621 5.5 14.9166L5.5 5.08325C5.5 3.83776 5.5 3.21501 5.75769 2.74627C5.94815 2.39983 6.23324 2.11473 6.57968 1.92428C7.04842 1.66659 7.67117 1.66659 8.91667 1.66659H12.0833C13.3288 1.66659 13.9516 1.66659 14.4203 1.92428C14.7668 2.11473 15.0519 2.39983 15.2423 2.74627C15.5 3.21501 15.5 3.83776 15.5 5.08325V14.9166C15.5 16.1621 15.5 16.7848 15.2423 17.2536C15.0519 17.6 14.7668 17.8851 14.4203 18.0756C13.9516 18.3333 13.3288 18.3333 12.0833 18.3333H8.91667C7.67117 18.3333 7.04842 18.3333 6.57968 18.0756C6.23324 17.8851 5.94815 17.6 5.75769 17.2536ZM9.44635 16.6667C9.06172 16.6667 8.74992 16.3964 8.74992 16.0631C8.74992 15.7298 9.06172 15.4595 9.44635 15.4595H11.5263C11.911 15.4595 12.2228 15.7298 12.2228 16.0631C12.2228 16.3964 11.911 16.6667 11.5263 16.6667H9.44635Z",
		fill: "white"
	})
});
const ForwardRef = forwardRef(SvgPhone);
export default ForwardRef;
